module.exports = __webpack_public_path__ + "img/th.626b1389.png";